module.exports = __webpack_public_path__ + "img/studentCardBg.3f1dbdcf.png";